export default "__VITE_ASSET__4jfkAScV__"